import { useEffect } from 'react';

/**
 * Sets document title, meta description, and optional JSON-LD schema per page.
 * For CRA (client-side rendered), this updates the DOM directly.
 */
export function useSEO({ title, description, schema, canonical }) {
  useEffect(() => {
    // Title
    if (title) {
      document.title = title;
    }

    // Meta description
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) {
        meta.setAttribute('content', description);
      }
    }

    // OG title
    if (title) {
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute('content', title);
      let twTitle = document.querySelector('meta[name="twitter:title"]');
      if (twTitle) twTitle.setAttribute('content', title);
    }

    // OG description
    if (description) {
      let ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute('content', description);
      let twDesc = document.querySelector('meta[name="twitter:description"]');
      if (twDesc) twDesc.setAttribute('content', description);
    }

    // Canonical + og:url
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (link) link.setAttribute('href', canonical);
      let ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) ogUrl.setAttribute('content', canonical);
    }

    // JSON-LD page-level schema
    let existingPageSchema = document.getElementById('page-schema');
    if (schema) {
      if (!existingPageSchema) {
        existingPageSchema = document.createElement('script');
        existingPageSchema.id = 'page-schema';
        existingPageSchema.type = 'application/ld+json';
        document.head.appendChild(existingPageSchema);
      }
      existingPageSchema.textContent = JSON.stringify(schema);
    } else if (existingPageSchema) {
      existingPageSchema.remove();
    }

    // Cleanup: restore defaults on unmount
    return () => {
      document.title = 'PlanningSearch | Find Building Projects Before Your Competitors';
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute('content', 'PlanningSearch is the UK\'s leading planning application intelligence platform. Browse live planning applications on a map, get AI-powered project insights, and win more building work.');
      let pageSchema = document.getElementById('page-schema');
      if (pageSchema) pageSchema.remove();
    };
  }, [title, description, schema, canonical]);
}
